import { formatDate } from '../utils/dateFormatter';

export default function PrivacyPage() {
    return (
        <div className="min-h-screen bg-black text-gray-300 py-20 px-6">
            <div className="max-w-4xl mx-auto">
                <h1 className="text-4xl font-bold text-white mb-8">Privacy Policy</h1>
                <p className="mb-4">Last updated: {formatDate(new Date())}</p>

                <section className="mb-8">
                    <h2 className="text-2xl font-semibold text-white mb-4">1. Information We Collect</h2>
                    <p className="mb-4">
                        We collect information you provide directly to us, such as when you create an account, update your profile, or use our interactive features like Bingo games.
                    </p>
                </section>

                <section className="mb-8">
                    <h2 className="text-2xl font-semibold text-white mb-4">2. How We Use Your Information</h2>
                    <p className="mb-4">
                        We use the information we collect to operate, maintain, and improve our services, and to communicate with you about your account and updates.
                    </p>
                </section>

                <section className="mb-8">
                    <h2 className="text-2xl font-semibold text-white mb-4">3. Data Security</h2>
                    <p className="mb-4">
                        We implement appropriate security measures to protect your personal information against unauthorized access, alteration, or destruction.
                    </p>
                </section>

                <section className="mb-8">
                    <h2 className="text-2xl font-semibold text-white mb-4">4. Contact Us</h2>
                    <p className="mb-4">
                        If you have any questions about this Privacy Policy, please contact us.
                    </p>
                </section>

                <div className="mt-12 border-t border-gray-800 pt-8">
                    <a href="/landing" className="text-purple-400 hover:text-purple-300">← Back to Home</a>
                </div>
            </div>
        </div>
    );
}
